/** Themed Profile namespace — keep en / zh / it in sync */
export const profileEn = {
  'profile.dashboard.action': 'Themed profile',
  'profile.dashboard.desc': 'Build and share your themed public profile page.',
  'profile.discover.dashboard.action': 'Discover profiles',
  'profile.discover.dashboard.desc':
    'Browse and search published provider and organizer profiles.',
  'profile.editor.title': 'Themed Profile',
  'profile.editor.subtitle': 'Editor',
  'profile.tab.basic': 'Basic',
  'profile.tab.theme': 'Theme',
  'profile.tab.content': 'Content',
  'profile.tab.stats': 'Stats',
  'profile.status.published': 'Published',
  'profile.status.draft': 'Draft',
  'profile.slug.available': 'Available',
  'profile.group.identity': 'Identity',
  'profile.group.publicUrl': 'Public URL',
  'profile.group.tags': 'Tags · used in discovery',
  'profile.group.template': 'Template',
  'profile.group.accent': 'Accent color',
  'profile.group.background': 'Background image · 16:9',
  'profile.group.typeface': 'Typeface',
  'profile.group.addBlock': 'Add a block',
  'profile.group.blocks': 'Your blocks',
  'profile.group.overview': 'Overview',
  'profile.group.clicksByBlock': 'Clicks by block',
  'profile.field.displayName': 'Display name',
  'profile.field.role': 'Role / tagline',
  'profile.field.taglinePlaceholder': 'Breathwork & Yoga · Lago di Como',
  'profile.field.bio': 'Bio',
  'profile.field.bioHelp': 'Shown under your tagline',
  'profile.field.location': 'Location',
  'profile.field.locationPlaceholder': 'Como, IT',
  'profile.field.slug': 'Profile slug',
  'profile.role.customer': 'Customer',
  'profile.role.travelAgency': 'Travel Agency',
  'profile.role.eventOrganizer': 'Event Organizer',
  'profile.role.facilityProvider': 'Facility Provider',
  'profile.role.serviceProvider': 'Service Provider',
  'profile.role.researchPartner': 'Research Partner',
  'profile.tag.add': 'Add',
  'profile.accent.help': 'Drives avatar, links and highlights',
  'profile.background.help': 'JPG / PNG / WebP · max 5MB · ≥ 1280×720',
  'profile.background.previewAlt': 'Background image preview',
  'profile.font.sans': 'Sans · Montserrat',
  'profile.font.serif': 'Serif · Playfair Display',
  'profile.font.mono': 'Monospace',
  'profile.block.social': 'Social',
  'profile.block.link': 'Link',
  'profile.block.youtube': 'YouTube',
  'profile.block.igPost': 'IG post',
  'profile.block.text': 'Text',
  'profile.block.image': 'Image',
  'profile.blocks.shown': '{visible} shown · {total} total',
  'profile.preview.label': 'Live preview · updates as you edit',
  'profile.preview.mobile': 'Mobile',
  'profile.preview.desktop': 'Desktop',
  'profile.action.upload': 'Upload',
  'profile.action.crop': 'Crop',
  'profile.action.uploadBackground': 'Upload background',
  'profile.action.removeBackground': 'Remove background',
  'profile.action.preview': 'Preview',
  'profile.action.saveDraft': 'Save draft',
  'profile.action.publish': 'Publish',
  'profile.action.unpublish': 'Unpublish',
  'profile.action.copyLink': 'Copy link',
  'profile.stats.views': 'Total views',
  'profile.stats.clicks': 'Link clicks',
  'profile.stats.ctr': 'Click-through',
  'profile.stats.liveBlocks': 'Live blocks',
  'profile.stats.live': 'Live',
  'profile.discover.eyebrow': 'Discover',
  'profile.discover.title': 'Find a practitioner or organizer',
  'profile.discover.subtitle':
    'Browse published N-Excelsior profiles — providers, studios and event teams across Italy.',
  'profile.discover.searchPlaceholder': 'Search by name, place or focus…',
  'profile.discover.count': '{count} profiles',
  'profile.discover.countOne': '1 profile',
  'profile.discover.countFiltered': '{count} profiles match your filters',
  'profile.discover.countPublished': '{count} profiles published',
  'profile.discover.emptyTitle': 'No profiles found',
  'profile.discover.emptyBody': 'Try a different name, or clear a filter or two.',
  'profile.discover.viewProfile': 'View profile',
  'profile.public.notFound': 'This profile is not available.',
  'profile.public.copy': 'Copy',
  'profile.public.footerMark': 'N·EXCELSIOR',
  'profile.toast.created': 'Profile created',
  'profile.toast.createFailed': 'Failed to create profile',
  'profile.toast.draftSaved': 'Draft saved',
  'profile.toast.saveFailed': 'Failed to save profile',
  'profile.toast.published': 'Published — your page is live',
  'profile.toast.publishFailed': 'Failed to publish',
  'profile.toast.unpublished': 'Unpublished — page now offline',
  'profile.toast.unpublishFailed': 'Failed to unpublish',
  'profile.toast.blockAdded': 'Block added',
  'profile.toast.blockAddFailed': 'Failed to add block',
  'profile.toast.linkCopied': 'Link copied',
  'profile.toast.themeApplied': '{name} applied',
  'profile.toast.previewDraft': 'Publish your profile to preview the public URL',
  'profile.toast.previewFailed': 'Could not open preview',
  'profile.toast.backgroundUploaded': 'Background image uploaded',
  'profile.toast.backgroundUploadFailed': 'Failed to upload background image',
  'profile.toast.backgroundInvalid': 'Use JPG, PNG or WebP under 5MB',
  'profile.toast.backgroundRemoved': 'Background image removed',
  'profile.toast.backgroundRemoveFailed': 'Failed to remove background image',
  'profile.toast.avatarUploaded': 'Avatar uploaded',
  'profile.toast.avatarUploadFailed': 'Failed to upload avatar',
  'profile.create.title': 'Create your profile',
  'profile.create.subtitle': 'Set up your themed public page to get started.',
  'profile.create.action': 'Create profile',
  'profile.create.defaultTitle': 'My Profile',
  'profile.stats.clickCount': '{count} clicks',
  'profile.discover.countShowing': '{count} profiles shown',
  'profile.preview.notFound': 'This preview link is invalid or has expired.',
  'profile.preset.socialLabel': 'Instagram',
  'profile.preset.socialHandle': '@handle',
  'profile.preset.linkLabel': 'New link',
  'profile.preset.linkNote': 'Add a description',
  'profile.preset.youtubeLabel': 'New video',
  'profile.preset.igLabel': 'Instagram post',
  'profile.preset.igCaption': 'New post',
  'profile.preset.textLabel': 'Heading',
  'profile.preset.textContent': 'Write something about your work.',
  'profile.preset.imageLabel': 'Image caption',
  'profile.field.blockUrl': 'URL',
  'profile.field.blockLabel': 'Label',
  'profile.field.blockHandle': 'Handle',
  'profile.field.blockNote': 'Description',
  'profile.field.blockCaption': 'Caption',
  'profile.field.blockHeading': 'Heading',
  'profile.field.blockBody': 'Body text',
  'profile.field.blockVideoUrl': 'Video URL',
  'profile.field.blockVideoUrlPlaceholder': 'https://www.youtube.com/watch?v=…',
  'profile.field.blockPlatform': 'Platform',
  'profile.field.blockImage': 'Image',
  'profile.action.uploadBlockImage': 'Upload image',
  'profile.action.removeBlockImage': 'Remove image',
  'profile.block.edit': 'Edit block',
  'profile.block.collapse': 'Collapse',
  'profile.toast.blockImageUploaded': 'Block image uploaded',
  'profile.toast.blockImageUploadFailed': 'Failed to upload block image',
  'profile.toast.blockImageRemoved': 'Block image removed',
  'profile.toast.blockImageRemoveFailed': 'Failed to remove block image',
} as const;

export const profileZh = {
  'profile.dashboard.action': '主题主页',
  'profile.dashboard.desc': '创建并分享你的主题化公开主页。',
  'profile.discover.dashboard.action': '发现主页',
  'profile.discover.dashboard.desc': '浏览并搜索已发布的服务商与组织者主页。',
  'profile.editor.title': '主题主页',
  'profile.editor.subtitle': '编辑器',
  'profile.tab.basic': '基本信息',
  'profile.tab.theme': '主题',
  'profile.tab.content': '内容',
  'profile.tab.stats': '统计',
  'profile.status.published': '已发布',
  'profile.status.draft': '草稿',
  'profile.slug.available': '可用',
  'profile.group.identity': '身份',
  'profile.group.publicUrl': '公开链接',
  'profile.group.tags': '标签 · 用于发现页筛选',
  'profile.group.template': '模板',
  'profile.group.accent': '强调色',
  'profile.group.background': '背景图 · 16:9',
  'profile.group.typeface': '字体',
  'profile.group.addBlock': '添加内容块',
  'profile.group.blocks': '你的内容块',
  'profile.group.overview': '概览',
  'profile.group.clicksByBlock': '各块点击量',
  'profile.field.displayName': '显示名称',
  'profile.field.role': '角色 / 标语',
  'profile.field.taglinePlaceholder': '呼吸练习与瑜伽 · 科莫湖',
  'profile.field.bio': '简介',
  'profile.field.bioHelp': '显示在标语下方',
  'profile.field.location': '位置',
  'profile.field.locationPlaceholder': '科莫, IT',
  'profile.field.slug': '主页路径',
  'profile.role.customer': '客户',
  'profile.role.travelAgency': '旅行社',
  'profile.role.eventOrganizer': '活动策划',
  'profile.role.facilityProvider': '场地方',
  'profile.role.serviceProvider': '服务方',
  'profile.role.researchPartner': '研究伙伴',
  'profile.tag.add': '添加',
  'profile.accent.help': '影响头像、链接与高亮',
  'profile.background.help': 'JPG / PNG / WebP · 最大 5MB · ≥ 1280×720',
  'profile.background.previewAlt': '背景图预览',
  'profile.font.sans': '无衬线 · Montserrat',
  'profile.font.serif': '衬线 · Playfair Display',
  'profile.font.mono': '等宽',
  'profile.block.social': '社交',
  'profile.block.link': '链接',
  'profile.block.youtube': 'YouTube',
  'profile.block.igPost': 'IG 帖子',
  'profile.block.text': '文本',
  'profile.block.image': '图片',
  'profile.blocks.shown': '显示 {visible} · 共 {total}',
  'profile.preview.label': '实时预览 · 编辑时同步更新',
  'profile.preview.mobile': '手机',
  'profile.preview.desktop': '桌面',
  'profile.action.upload': '上传',
  'profile.action.crop': '裁剪',
  'profile.action.uploadBackground': '上传背景图',
  'profile.action.removeBackground': '移除背景图',
  'profile.action.preview': '预览',
  'profile.action.saveDraft': '保存草稿',
  'profile.action.publish': '发布',
  'profile.action.unpublish': '取消发布',
  'profile.action.copyLink': '复制链接',
  'profile.stats.views': '总浏览量',
  'profile.stats.clicks': '链接点击',
  'profile.stats.ctr': '点击率',
  'profile.stats.liveBlocks': '在线内容块',
  'profile.stats.live': '实时',
  'profile.discover.eyebrow': '发现',
  'profile.discover.title': '寻找从业者或组织者',
  'profile.discover.subtitle': '浏览意大利各地已发布的 N-Excelsior 主页。',
  'profile.discover.searchPlaceholder': '按名称、地点或领域搜索…',
  'profile.discover.count': '{count} 个主页',
  'profile.discover.countOne': '1 个主页',
  'profile.discover.countFiltered': '{count} 个主页符合筛选',
  'profile.discover.countPublished': '已发布 {count} 个主页',
  'profile.discover.emptyTitle': '未找到主页',
  'profile.discover.emptyBody': '试试其他关键词，或清除部分筛选条件。',
  'profile.discover.viewProfile': '查看主页',
  'profile.public.notFound': '该主页不可用。',
  'profile.public.copy': '复制',
  'profile.public.footerMark': 'N·EXCELSIOR',
  'profile.toast.created': '主页已创建',
  'profile.toast.createFailed': '创建主页失败',
  'profile.toast.draftSaved': '草稿已保存',
  'profile.toast.saveFailed': '保存失败',
  'profile.toast.published': '已发布 — 你的页面已上线',
  'profile.toast.publishFailed': '发布失败',
  'profile.toast.unpublished': '已取消发布 — 页面已下线',
  'profile.toast.unpublishFailed': '取消发布失败',
  'profile.toast.blockAdded': '内容块已添加',
  'profile.toast.blockAddFailed': '添加内容块失败',
  'profile.toast.linkCopied': '链接已复制',
  'profile.toast.themeApplied': '已应用 {name}',
  'profile.toast.previewDraft': '请先发布主页后再预览公开链接',
  'profile.toast.previewFailed': '无法打开预览',
  'profile.toast.backgroundUploaded': '背景图已上传',
  'profile.toast.backgroundUploadFailed': '背景图上传失败',
  'profile.toast.backgroundInvalid': '请使用 5MB 以内的 JPG、PNG 或 WebP',
  'profile.toast.backgroundRemoved': '背景图已移除',
  'profile.toast.backgroundRemoveFailed': '移除背景图失败',
  'profile.toast.avatarUploaded': '头像已上传',
  'profile.toast.avatarUploadFailed': '头像上传失败',
  'profile.create.title': '创建你的主页',
  'profile.create.subtitle': '先设置主题化公开主页的基本信息。',
  'profile.create.action': '创建主页',
  'profile.create.defaultTitle': '我的主页',
  'profile.stats.clickCount': '{count} 次点击',
  'profile.discover.countShowing': '显示 {count} 个主页',
  'profile.preview.notFound': '预览链接无效或已过期。',
  'profile.preset.socialLabel': 'Instagram',
  'profile.preset.socialHandle': '@账号',
  'profile.preset.linkLabel': '新链接',
  'profile.preset.linkNote': '添加描述',
  'profile.preset.youtubeLabel': '新视频',
  'profile.preset.igLabel': 'Instagram 帖子',
  'profile.preset.igCaption': '新帖子',
  'profile.preset.textLabel': '标题',
  'profile.preset.textContent': '写一些关于你工作的内容。',
  'profile.preset.imageLabel': '图片说明',
  'profile.field.blockUrl': '链接',
  'profile.field.blockLabel': '标题',
  'profile.field.blockHandle': '账号',
  'profile.field.blockNote': '描述',
  'profile.field.blockCaption': '说明文字',
  'profile.field.blockHeading': '标题',
  'profile.field.blockBody': '正文',
  'profile.field.blockVideoUrl': '视频链接',
  'profile.field.blockVideoUrlPlaceholder': 'https://www.youtube.com/watch?v=…',
  'profile.field.blockPlatform': '平台',
  'profile.field.blockImage': '图片',
  'profile.action.uploadBlockImage': '上传图片',
  'profile.action.removeBlockImage': '移除图片',
  'profile.block.edit': '编辑内容块',
  'profile.block.collapse': '收起',
  'profile.toast.blockImageUploaded': '内容块图片已上传',
  'profile.toast.blockImageUploadFailed': '内容块图片上传失败',
  'profile.toast.blockImageRemoved': '内容块图片已移除',
  'profile.toast.blockImageRemoveFailed': '移除内容块图片失败',
} as const;

export const profileIt = {
  'profile.dashboard.action': 'Profilo tematico',
  'profile.dashboard.desc': 'Crea e condividi la tua pagina pubblica tematica.',
  'profile.discover.dashboard.action': 'Scopri profili',
  'profile.discover.dashboard.desc':
    'Sfoglia e cerca profili pubblicati di provider e organizzatori.',
  'profile.editor.title': 'Profilo tematico',
  'profile.editor.subtitle': 'Editor',
  'profile.tab.basic': 'Base',
  'profile.tab.theme': 'Tema',
  'profile.tab.content': 'Contenuti',
  'profile.tab.stats': 'Statistiche',
  'profile.status.published': 'Pubblicato',
  'profile.status.draft': 'Bozza',
  'profile.slug.available': 'Disponibile',
  'profile.group.identity': 'Identità',
  'profile.group.publicUrl': 'URL pubblico',
  'profile.group.tags': 'Tag · usati nella scoperta',
  'profile.group.template': 'Template',
  'profile.group.accent': 'Colore di accento',
  'profile.group.background': 'Immagine di sfondo · 16:9',
  'profile.group.typeface': 'Carattere',
  'profile.group.addBlock': 'Aggiungi un blocco',
  'profile.group.blocks': 'I tuoi blocchi',
  'profile.group.overview': 'Panoramica',
  'profile.group.clicksByBlock': 'Click per blocco',
  'profile.field.displayName': 'Nome visualizzato',
  'profile.field.role': 'Ruolo / tagline',
  'profile.field.taglinePlaceholder': 'Breathwork & Yoga · Lago di Como',
  'profile.field.bio': 'Bio',
  'profile.field.bioHelp': 'Mostrato sotto la tagline',
  'profile.field.location': 'Località',
  'profile.field.locationPlaceholder': 'Como, IT',
  'profile.field.slug': 'Slug del profilo',
  'profile.role.customer': 'Cliente',
  'profile.role.travelAgency': 'Agenzia di viaggi',
  'profile.role.eventOrganizer': 'Event Organizer',
  'profile.role.facilityProvider': 'Struttura ospitante',
  'profile.role.serviceProvider': 'Service Provider',
  'profile.role.researchPartner': 'Research Partner',
  'profile.tag.add': 'Aggiungi',
  'profile.accent.help': 'Guida avatar, link ed evidenziazioni',
  'profile.background.help': 'JPG / PNG / WebP · max 5MB · ≥ 1280×720',
  'profile.background.previewAlt': 'Anteprima immagine di sfondo',
  'profile.font.sans': 'Sans · Montserrat',
  'profile.font.serif': 'Serif · Playfair Display',
  'profile.font.mono': 'Monospace',
  'profile.block.social': 'Social',
  'profile.block.link': 'Link',
  'profile.block.youtube': 'YouTube',
  'profile.block.igPost': 'Post IG',
  'profile.block.text': 'Testo',
  'profile.block.image': 'Immagine',
  'profile.blocks.shown': '{visible} visibili · {total} totali',
  'profile.preview.label': 'Anteprima live · si aggiorna mentre modifichi',
  'profile.preview.mobile': 'Mobile',
  'profile.preview.desktop': 'Desktop',
  'profile.action.upload': 'Carica',
  'profile.action.crop': 'Ritaglia',
  'profile.action.uploadBackground': 'Carica sfondo',
  'profile.action.removeBackground': 'Rimuovi sfondo',
  'profile.action.preview': 'Anteprima',
  'profile.action.saveDraft': 'Salva bozza',
  'profile.action.publish': 'Pubblica',
  'profile.action.unpublish': 'Rimuovi pubblicazione',
  'profile.action.copyLink': 'Copia link',
  'profile.stats.views': 'Visualizzazioni totali',
  'profile.stats.clicks': 'Click sui link',
  'profile.stats.ctr': 'Click-through',
  'profile.stats.liveBlocks': 'Blocchi attivi',
  'profile.stats.live': 'Live',
  'profile.discover.eyebrow': 'Scopri',
  'profile.discover.title': 'Trova un professionista o organizzatore',
  'profile.discover.subtitle':
    'Sfoglia i profili N-Excelsior pubblicati — provider, studi e team eventi in Italia.',
  'profile.discover.searchPlaceholder': 'Cerca per nome, luogo o focus…',
  'profile.discover.count': '{count} profili',
  'profile.discover.countOne': '1 profilo',
  'profile.discover.countFiltered': '{count} profili corrispondono ai filtri',
  'profile.discover.countPublished': '{count} profili pubblicati',
  'profile.discover.emptyTitle': 'Nessun profilo trovato',
  'profile.discover.emptyBody': 'Prova un altro nome o rimuovi qualche filtro.',
  'profile.discover.viewProfile': 'Vedi profilo',
  'profile.public.notFound': 'Questo profilo non è disponibile.',
  'profile.public.copy': 'Copia',
  'profile.public.footerMark': 'N·EXCELSIOR',
  'profile.toast.created': 'Profilo creato',
  'profile.toast.createFailed': 'Creazione profilo fallita',
  'profile.toast.draftSaved': 'Bozza salvata',
  'profile.toast.saveFailed': 'Salvataggio fallito',
  'profile.toast.published': 'Pubblicato — la pagina è online',
  'profile.toast.publishFailed': 'Pubblicazione fallita',
  'profile.toast.unpublished': 'Non pubblicato — pagina offline',
  'profile.toast.unpublishFailed': 'Rimozione pubblicazione fallita',
  'profile.toast.blockAdded': 'Blocco aggiunto',
  'profile.toast.blockAddFailed': 'Aggiunta blocco fallita',
  'profile.toast.linkCopied': 'Link copiato',
  'profile.toast.themeApplied': '{name} applicato',
  'profile.toast.previewDraft': 'Pubblica il profilo per vedere l’URL pubblico',
  'profile.toast.previewFailed': 'Impossibile aprire l’anteprima',
  'profile.toast.backgroundUploaded': 'Immagine di sfondo caricata',
  'profile.toast.backgroundUploadFailed': 'Caricamento sfondo fallito',
  'profile.toast.backgroundInvalid': 'Usa JPG, PNG o WebP sotto i 5MB',
  'profile.toast.backgroundRemoved': 'Immagine di sfondo rimossa',
  'profile.toast.backgroundRemoveFailed': 'Rimozione sfondo fallita',
  'profile.toast.avatarUploaded': 'Avatar caricato',
  'profile.toast.avatarUploadFailed': 'Caricamento avatar fallito',
  'profile.create.title': 'Crea il tuo profilo',
  'profile.create.subtitle': 'Configura la tua pagina pubblica tematica per iniziare.',
  'profile.create.action': 'Crea profilo',
  'profile.create.defaultTitle': 'Il mio profilo',
  'profile.stats.clickCount': '{count} click',
  'profile.discover.countShowing': '{count} profili mostrati',
  'profile.preview.notFound': 'Link di anteprima non valido o scaduto.',
  'profile.preset.socialLabel': 'Instagram',
  'profile.preset.socialHandle': '@handle',
  'profile.preset.linkLabel': 'Nuovo link',
  'profile.preset.linkNote': 'Aggiungi una descrizione',
  'profile.preset.youtubeLabel': 'Nuovo video',
  'profile.preset.igLabel': 'Post Instagram',
  'profile.preset.igCaption': 'Nuovo post',
  'profile.preset.textLabel': 'Titolo',
  'profile.preset.textContent': 'Scrivi qualcosa sul tuo lavoro.',
  'profile.preset.imageLabel': 'Didascalia immagine',
  'profile.field.blockUrl': 'URL',
  'profile.field.blockLabel': 'Etichetta',
  'profile.field.blockHandle': 'Handle',
  'profile.field.blockNote': 'Descrizione',
  'profile.field.blockCaption': 'Didascalia',
  'profile.field.blockHeading': 'Titolo',
  'profile.field.blockBody': 'Testo',
  'profile.field.blockVideoUrl': 'URL video',
  'profile.field.blockVideoUrlPlaceholder': 'https://www.youtube.com/watch?v=…',
  'profile.field.blockPlatform': 'Piattaforma',
  'profile.field.blockImage': 'Immagine',
  'profile.action.uploadBlockImage': 'Carica immagine',
  'profile.action.removeBlockImage': 'Rimuovi immagine',
  'profile.block.edit': 'Modifica blocco',
  'profile.block.collapse': 'Comprimi',
  'profile.toast.blockImageUploaded': 'Immagine del blocco caricata',
  'profile.toast.blockImageUploadFailed': 'Caricamento immagine blocco fallito',
  'profile.toast.blockImageRemoved': 'Immagine del blocco rimossa',
  'profile.toast.blockImageRemoveFailed': 'Rimozione immagine blocco fallita',
} as const;
